import { render, staticRenderFns } from "./SettingsPageMobile.vue?vue&type=template&id=d8e9c496&"
import script from "./SettingsPageMobile.vue?vue&type=script&lang=js&"
export * from "./SettingsPageMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports